import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { interval } from 'rxjs';
import { bounceIn } from 'src/app/animations/custom.animation';
import { IonicModule } from '@ionic/angular';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';
@Component({
    selector: 'app-issue-award',
    templateUrl: './issue-award.component.html',
    styleUrls: ['./issue-award.component.scss', "../onesignal.scss"],
    animations: [bounceIn],
    standalone: true,
    imports: [IonicModule, MatProgressSpinner, MatIcon, TranslatePipe]
})
export class IssueAwardComponent implements OnInit {
  spinnerAnimation: boolean;
  progressBar: number;
  proceed: boolean = true;

  constructor(private router: Router,
    public translate: TranslateService,
    private authService: AuthService,) {
    this.authService.selectedlanguage$.subscribe((l) => {
      translate.use(l ? l : "en");
    }, (err => {
      return err
    }));
  }

  ngOnInit() { }

  navigateToRegistrationDefault() {
    this.spinnerAnimation = true;
    this.progressBar = 0;
    const timer$ = interval(20);

    const sub = timer$.subscribe((sec) => {
      this.progressBar = 0 + sec;

      if (this.progressBar === 100) {
        sub.unsubscribe();
        setTimeout(() => {
          this.spinnerAnimation = false;
          this.proceed = false;
          setTimeout(() => {
            this.router.navigateByUrl("free-reg-complete-profile");
          }, 2000)
        }, 2000)
      }
    }, (err => {
      return err
    }));
  }
}
